module.exports = __webpack_public_path__ + "img/image164.fd26b954.jpg";